import React from 'react';
import BlockUserDrawer from '../components/BlockUserDrawer';
import { useBlockUserMutation } from '../graphql/blockUser';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
export default function useBlockUser() {
    const [blockUserMutationState, blockUserMutationActions] = useBlockUserMutation();
    const block = (userID) => {
        bottomDrawerHelperActions.show({
            component: (React.createElement(BlockUserDrawer, { onConfirm: () => {
                    bottomDrawerHelperActions.hide();
                    blockUserMutationActions.submit({
                        variables: {
                            userID,
                        },
                    });
                } })),
        });
    };
    return [blockUserMutationState, { block }];
}
